import { AutoComplete } from 'antd';
import { IconSearch, IconX, IconUsers } from '@tabler/icons-react';
import { useQuery } from '@tanstack/react-query';
import { customersGroupsQueryOptions } from '../../utils/queryOptions';
import { useState } from 'react';
import { ShopNewsRecipient, CustomersGroup } from '@next-is-free-monorepo/next-is-free-types';
import NAvatar from '../../../../libs/nif-web-components/src/microcomponents/NAvatar';
import { UserGroupIcon, UserIcon, Mail01Icon } from '@hugeicons/core-free-icons';
import { NTag } from '@next-is-free-monorepo/nif-web-components';

interface GroupsAutocompleteProps {
  selectedGroups: ShopNewsRecipient['recipients'];
  setSelectedGroups: (selected: ShopNewsRecipient['recipients']) => void;
}

const GroupsAutocomplete = ({
                             setSelectedGroups,
                             selectedGroups
                           }: GroupsAutocompleteProps) => {

  const [search, setSearch] = useState('');

  const groups = useQuery(customersGroupsQueryOptions());

  const filteredGroups = groups.data?.filter((group) =>
    search ? group.name?.toLowerCase().includes(search.toLowerCase()) : true
  ).map((group) => {
    const isSelected = selectedGroups.some((s) => s.id === group.id);

    return {
      key: group.id,
      value: group.id,
      label: group.name || 'Gruppo senza nome',
      type: group.type,
      isSelected,
      disabled: isSelected
    };
  }) || [];

  return (
    <div>
      <AutoComplete
        optionRender={(value) => <GroupRow
          label={value.data.label as string}
          type={value.data.type as 'manual' | 'automatic'}
          isSelected={value.data.isSelected}
        />}
        options={filteredGroups}
        value={search}
        onSelect={(value, option) => {
          setSelectedGroups([...selectedGroups, { id: option.value, label: option.label as string }]);
          setSearch('');
        }}
        onSearch={(value) => setSearch(value)}
        className={'w-full'}
        prefix={<IconSearch size={13} className={'text-slate-300'} />}
        notFoundContent={<p className={'text-slate-400'}>Nessun Gruppo trovato</p>}
        placeholder={'Cerca nome gruppo'}
      />
      <div className={'flex flex-wrap gap-2 mt-2'}>
        {selectedGroups.map((selectedGroup) => {
          const groupData = groups.data?.find(g => g.id === selectedGroup.id);
          return (
            <div key={selectedGroup.id} className={'px-0.5 py-0.5 rounded-full border flex items-center gap-2'}>
              <GroupRow
                isSelected={false}
                label={selectedGroup.label}
                type={groupData?.type || 'manual'}
              />
              <IconX
                onClick={() => {
                  const next = selectedGroups.filter(item => item.id !== selectedGroup.id);
                  setSelectedGroups(next);
                }}
                size={14}
                className="mr-2 text-slate-300 hover:text-black cursor-pointer"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default GroupsAutocomplete;

function GroupRow({ label, type, isSelected }: { label: string; type: 'manual' | 'automatic'; isSelected: boolean }) {
  return (
    <div className="flex gap-2 items-center line-clamp-1 overflow-hidden">
      <NAvatar
        hugeIcon={UserGroupIcon}
        size="xs"
        color={isSelected ? 'tertiary' : 'primary'}
      />
      <span>{label}</span>
      <span className="text-xs text-slate-400 ml-auto">
        {type === 'automatic' ? 'Auto' : 'Manuale'}
      </span>
    </div>
  );
}
